export enum PermissionRoles {
  GG_RO_HQ_IT_DEX_GOV_SRV_ADMIN = 'GG_RO_HQ_IT_DEX_GOV_SRV_ADMIN',
  GG_RO_HQ_IT_DEX_GOV_DOMAIN_TL = 'GG_RO_HQ_IT_DEX_GOV_DOMAIN_TL',
  GG_RO_HQ_IT_DEX_GOV_IT_DOMAIN_MEMBER = 'GG_RO_HQ_IT_DEX_GOV_IT_DOMAIN_MEMBER',
  GG_RO_HQ_IT_DEX_GOV_REGION_ADMIN = 'REGION_ADMIN',
  GG_RO_HQ_IT_DEX_GOV_IT_PM = 'GG_RO_HQ_IT_DEX_GOV_IT_PM'
}
